import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import {
    getOAuthErrorMessage,
    getPostLoginPath,
    saveAuthFromQueryParams,
} from "../commons/authStorage";

/**
 * Landing page after ai_backend redirects back from Military OAuth (Option B).
 * URL example: /login/callback?token=...&role=Admin&name=...
 */
const LoginCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        const oauthError = searchParams.get("error");
        if (oauthError) {
            setErrorMessage(
                getOAuthErrorMessage(oauthError, searchParams.get("error_description"))
            );
            return;
        }

        try {
            const { role } = saveAuthFromQueryParams(searchParams);
            navigate(getPostLoginPath(role), { replace: true });
        } catch (err) {
            setErrorMessage(getOAuthErrorMessage(err.message));
        }
    }, [searchParams, navigate]);

    if (errorMessage) {
        return (
            <div className="bg-backGray h-screen pt-[106px] flex justify-center">
                <div className="w-[399px] min-h-[220px] h-fit bg-white rounded-[25px] shadow-main-shadow py-[28px] px-[46px]">
                    <p className="text-center text-[#ff0000] text-sm font-IRANYekanMedium mb-6">
                        {errorMessage}
                    </p>
                    <Link
                        to="/"
                        className="w-full h-[40px] bg-mainColor2 hover:bg-nextColor shadow-norm-shadow rounded-[5px] flex justify-center items-center"
                    >
                        <p className="font-IRANYekanExtra text-[15px] text-white">تلاش مجدد</p>
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-backGray h-screen flex justify-center items-center">
            <div className="text-center">
                <ClipLoader color="#3b82f6" size={40} />
                <p className="mt-4 font-IRANYekanMedium text-[15px]">در حال تکمیل ورود...</p>
            </div>
        </div>
    );
};

export default LoginCallback;
